import { uuidv4 } from '@shared/utils/utils';
import {
  WOUNDSIZE_PREFIX,
  WOUNDTRACK_FILE_EXTENSION,
  WOUNDTRACK_PREFIX,
  WOUNDTYPE_PREFIX,
} from '../config/woundtrack-export.config';

export const getWoundtrackFileName = (): string => `${WOUNDTRACK_PREFIX}-${uuidv4()}.${WOUNDTRACK_FILE_EXTENSION}`;
export const getWoundsizeFileName = (): string => `${WOUNDSIZE_PREFIX}-${uuidv4()}.${WOUNDTRACK_FILE_EXTENSION}`;
export const getWoundtypeFileName = (): string => `${WOUNDTYPE_PREFIX}-${uuidv4()}.${WOUNDTRACK_FILE_EXTENSION}`;
